// @flow
import $ from 'jquery';
import 'fg-frontend/plugins/jquery.gm';


/**
 Googlemaps
 */
export default (): void => {

/*
  $.googlemap.setDefaults({
    mapOptions: {
      scrollwheel: false,
      mapTypeControl: false,
      streetViewControl: false,
      styles: [
        {"featureType": "landscape", "stylers": [{"saturation": -100}, {"lightness": 65}, {"visibility": "on"}]}, {
          "featureType": "poi",
          "stylers": [{"saturation": -100}, {"lightness": 51}, {"visibility": "simplified"}]
        }, {"featureType": "road.highway", "stylers": [{"saturation": -100}, {"visibility": "simplified"}]}, {
          "featureType": "road.arterial",
          "stylers": [{"saturation": -100}, {"lightness": 30}, {"visibility": "on"}]
        }, {"featureType": "road.local", "stylers": [{"saturation": -100}, {"lightness": 40}, {"visibility": "on"}]}, {
          "featureType": "transit",
          "stylers": [{"saturation": -100}, {"visibility": "simplified"}]
        }, {"featureType": "administrative.province", "stylers": [{"visibility": "off"}]}, {
          "featureType": "water",
          "elementType": "labels",
          "stylers": [{"visibility": "on"}, {"lightness": -25}, {"saturation": -100}]
        }, {"featureType": "water", "elementType": "geometry", "stylers": [{"hue": "#ffff00"}, {"lightness": -25}, {"saturation": -97}]}
      ]
    },
    markerTypes: [
      {},
      {
        icon: {
          url: '/img/google-map/marker-01.png',
          size: new google.maps.Size(46, 46),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(23, 23)
        },
        shape: {
          coords: [0, 0, 46, 46],
          type: 'rect'
        }
      },
      {
        icon: {
          url: '/img/google-map/marker-02.png',
          size: new google.maps.Size(46, 46),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(23, 23)
        },
        shape: {
          coords: [0, 0, 46, 46],
          type: 'rect'
        }
      }
    ],
    bubbleContentFormatter: function (mData) {
      let str = '';
      if (mData.title) {
        str += '<p class="h3 title">' + mData.title + '</p>';
      }
      if (mData.bubbleContent) {
        str += mData.bubbleContent;
      }
      return str;

    }
  });
*/

  projectConfig = projectConfig || {};

  projectConfig.googlemaps = projectConfig.googlemaps || {};
  projectConfig.googlemaps.activeMarker = null;

  /** create googlemap card
  projectConfig.googlemaps.createCard = function (data) {
    var str = '';
    var titlePrefix = '';
    str += '<div class="googleMapCardIn">';
    str += '<div class="clearfix">';
    str += '<div class="googleMapCardContentCnt">';
    str += '<h2>Pobočky</h2>';
    str += '<h3>' + titlePrefix + data.title + '</h3>';
    str += '<address>';
    if (data.street && data.street != "") {
      str += '<p>';
      str += data.street;
      if (data.num && data.num != "") {
        str += ' ';
        str += data.num;
      }
      str += '</p>';
    }
    if (data.city && data.city != "") {
      str += '<p>';
      str += data.city;
      str += '</p>';
      if (data.zip && data.zip != "") {
        str += '<p>';
        str += data.zip;
        str += '</p>';
      }
    }
    str += '</address>';
    if (data.phone && (!(data.phone == "" || data.phone.toLowerCase() == "null"))) {
      str += '<p><span>Tel: </span>' + data.phone + '</p>';
    }
    if (data.mobile && (!(data.mobile == "" || data.mobile.toLowerCase() == "null"))) {
      str += '<p><span>Mob: </span>' + data.mobile + '</p>';
    }
    if (data.fax && (!(data.fax == "" || data.fax.toLowerCase() == "null"))) {
      str += '<p><span>Fax: </span>' + data.fax + '</p>';
    }
    if (data.email && (!(data.email == "" || data.email.toLowerCase() == "null"))) {
      str += '<p><span>Email: </span><a href="mailto:' + data.email + '">' + data.email + '</a></p>';
    }
    if (data.openingHours && data.openingHours != null) {
      str += '<table class="table table-condensed">';
      if (data.openingHours.mo && data.openingHours.mo.hours ) {
        str += '<tr>';
        str += '<td>';
        str += 'Pondělí:';
        str += '</td>';
        if (data.openingHours.mo.hours) {
          str += '<td>';
          str += '<strong>';
          str += data.openingHours.mo.hours;
          str += '</strong>';
          str += '</td>';
        }
        str += '</tr>';
      }
      if (data.openingHours.tu && data.openingHours.tu.hours) {
        str += '<tr>';
        str += '<td>';
        str += 'Úterý:';
        str += '</td>';
        if (data.openingHours.tu.hours) {
          str += '<td>';
          str += '<strong>';
          str += data.openingHours.tu.hours;
          str += '</strong>';
          str += '</td>';
        }
        str += '</tr>';
      }
      if (data.openingHours.we && data.openingHours.we.hours) {
        str += '<tr>';
        str += '<td>';
        str += 'Středa:';
        str += '</td>';
        if (data.openingHours.we.hours) {
          str += '<td>';
          str += '<strong>';
          str += data.openingHours.we.hours;
          str += '</strong>';
          str += '</td>';
        }
        str += '</tr>';
      }
      if (data.openingHours.th && data.openingHours.th.hours) {
        str += '<tr>';
        str += '<td>';
        str += 'Čtvrtek:';
        str += '</td>';
        if (data.openingHours.th.hours) {
          str += '<td>';
          str += '<strong>';
          str += data.openingHours.th.hours;
          str += '</strong>';
          str += '</td>';
        }
        str += '</tr>';
      }
      if (data.openingHours.fr && data.openingHours.fr.hours) {
        str += '<tr>';
        str += '<td>';
        str += 'Pátek:';
        str += '</td>';
        if (data.openingHours.fr.hours) {
          str += '<td>';
          str += '<strong>';
          str += data.openingHours.fr.hours;
          str += '</strong>';
          str += '</td>';
        }
        str += '</tr>';
      }
      if (data.openingHours.st && data.openingHours.st.hours) {
        str += '<tr>';
        str += '<td>';
        str += 'Sobota:';
        str += '</td>';
        if (data.openingHours.st.hours) {
          str += '<td>';
          str += '<strong>';
          str += data.openingHours.st.hours;
          str += '</strong>';
          str += '</td>';
        }
        str += '</tr>';
      }
      if (data.openingHours.su && data.openingHours.su.hours) {
        str += '<tr>';
        str += '<td>';
        str += 'Neděle:';
        str += '</td>';
        if (data.openingHours.su.hours) {
          str += '<td>';
          str += '<strong>';
          str += data.openingHours.su.hours;
          str += '</strong>';
          str += '</td>';
        }
        str += '</tr>';
      }
      str += '</table>';
    }
    if (data.description && data.description != "") {
      str += '<div class="googleMapCardDescription">';
      str += data.description;
      str += '</div>';

    }
    str += '</div>';
    str += '<span class="googleMapCardClose">Zavřít</span>';
    str += '</div>';

    return str;

  }; */

  /** detect street view
  projectConfig.googlemaps.detectStreetViewImage = function (marker, data) {

    if (data.branchType == 'csas') {
      var $card = $('.googleMapCard', $(marker.container).parent());
      var url = 'https://maps.googleapis.com/maps/api/streetview/metadata?size=287x368&location=' + (data.lat).toString() + ',' + (data.lng).toString() + '&fov=90&heading=235&pitch=10&key=AIzaSyD1Arw77K0ngiTRnIkPosMJKZqYO3Ttowk';
      var imgUrl = '<img class="googleMapCardStreetViewThumbnail" src="https://maps.googleapis.com/maps/api/streetview?size=287x368&location=' + (data.lat).toString() + ',' + (data.lng).toString() + '&fov=90&heading=235&pitch=10&key=AIzaSyD1Arw77K0ngiTRnIkPosMJKZqYO3Ttowk" alt="" /><img class="googleMapCardMapThumbnail" src="/img/google-map/map-placeholder.jpg" alt="" /><button class="btn btn-inverse" id="gmapStreetViewTrigger">Street view</button><button class="btn" id="gmapMapTrigger">Mapa</button>';

      $.getJSON(url, function (jsonData) {
        if (jsonData.status == 'OK') {
          $('.googleMapCardStreetViewCnt', $card).html(imgUrl);
          $('.googleMapCardMapThumbnail, #gmapMapTrigger').hide();
          $('.googleMapCardStreetViewThumbnail', $card).on('load', function () {
            if ($('#gmapMapTrigger').is(':hidden')) {
              $('.googleMapCardStreetViewCnt #gmapStreetViewTrigger', $card).fadeIn();
            }
          });

          var panorama = marker.map.getStreetView();

          var latLng = new google.maps.LatLng(data.lat, data.lng);
          panorama.setPosition(latLng);
          panorama.setPov({
            heading: 0,
            pitch: 0
          });

          var pointerPanoramaOn = document.getElementById("gmapStreetViewTrigger");
          google.maps.event.addDomListener(pointerPanoramaOn, 'click', showPanorama);

          var pointerPanoramaOff = document.getElementById("gmapMapTrigger");
          google.maps.event.addDomListener(pointerPanoramaOff, 'click', hidePanorama);

          function showPanorama() {
            panorama.setVisible(true);
            $('.googleMapCardStreetViewThumbnail, #gmapStreetViewTrigger').hide();
            $('.googleMapCardMapThumbnail').css({'display': 'block'});
            $('#gmapMapTrigger').show();
          }

          function hidePanorama() {
            panorama.setVisible(false);
            $('.googleMapCardMapThumbnail, #gmapMapTrigger').hide();
            $('.googleMapCardStreetViewThumbnail').css({'display': 'block'});
            $('#gmapStreetViewTrigger').show();
          }

        } else {
          $('.googleMapCardStreetViewCnt', $card).html('<div class="withoutStreetView"><img src="/img/google-map/without-streetview.png" alt="" /></div>');
        }
      });
      //var map = new google.maps.Map(document.getElementById('googleMap'));
      //console.log(marker.map);
    }
  };
  */

  /** vyhledávání nad mapou
  projectConfig.googlemaps.handleSearchInput = function () {
    $(document).on('submit', '.gmapBranchesForm', function (e) {
      e.preventDefault();
      var gmapInputText = $('input[type="text"]', this).val();
      var bounds = new google.maps.LatLngBounds();

      dataLayer.push({
        'event': 'fgWebAnalytics',
        'fgVarType': '',
        'fgVarCat': 'Mapa',
        'fgVarAct': 'Vyhledávání',
        'fgVarLbl': gmapInputText,
        'fgVarTxt': ''
      });

      if (!!$('#branches').length) {
        scrollToAnchor('#branches');
      }

      // console.log(gmapInputText);

      $('#googleMap').googlemap("filterObjects", "markers", {}, {
        fulltextData: [gmapInputText]
      }, {
        onMarkerSuccess: function (marker) {
          bounds.extend(marker.position);

          var timeout = setTimeout(function () {
            $('#googleMap').googlemap('zoomToMarkersBoundsCustom', bounds);
          }, 1000);

        }
      });
    });
  };
  */

  /** activate close button
  projectConfig.googlemaps.handleCloseCard = function (marker) {
    var $card = $('.googleMapCard', $(marker.container).parent());
    $('.googleMapCardClose', $card).bind('click', function () {
      //projectConfig.googlemaps.activeMarker = projectConfig.googlemaps.setMarkerIcon(marker, false);
      var inactiveIcon = {
        url: '/img/google-map/marker-01.png',
        size: new google.maps.Size(46, 46),			// size of marker in px [x - width, y - height]
        origin: new google.maps.Point(0, 0),		// position of marker image in sprite (if given) [x - position from the left, y - position from the top]
        anchor: new google.maps.Point(23, 23)     	// tip of the marker [x - from the left, y - from the top]
      };
      projectConfig.googlemaps.activeIcon.setOptions({
        icon: inactiveIcon
      });
      marker.opened = false;
      $card.empty().hide();
      $('.gmap-branches-cnt').removeClass('gmap-branches-cnt-active');
    });
  };*/

  // resize map
  projectConfig.googlemaps.resizeMapOnEvent = function () {
    if (window.innerWidth <= 348) {
      $('#googleMap').googlemap('setCenterAndZoom', {
        lat: 50.0701842,
        lng: 15.5009503,
        zoom: 4
      });
    } else if ((window.innerWidth >= 359) && (window.innerWidth <= 659)) {
      $('#googleMap').googlemap('setCenterAndZoom', {
        lat: 50.0701842,
        lng: 15.5009503,
        zoom: 5
      });
    } else if ((window.innerWidth >= 660) && (window.innerWidth <= 1052)) {
      $('#googleMap').googlemap('setCenterAndZoom', {
        lat: 50.0701842,
        lng: 15.5009503,
        zoom: 6
      });
    } else if (window.innerWidth >= 1053) {
      $('#googleMap').googlemap('setCenterAndZoom', {
        lat: 49.7701842,
        lng: 15.6009503,
        zoom: 7
      });
    }
  };

  window.projectConfig = projectConfig;
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/jquery.gm.conf.js